import { DocumentReference } from '@21st-night/utils';

export function deleteStudyPlanTemplate(
  templateRef: DocumentReference,
): Promise<void> {
  return templateRef.delete();
}
